import { render } from "./StatusItem.vue?vue&type=template&id=710d35ca"
import script from "./StatusItem.vue?vue&type=script&lang=js"
export * from "./StatusItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__